/*
 * @Author: wangsong wangsssong@163.com
 * @Date: 2024-07-14 16:07:53
 * @LastEditors: wangsong wangsssong@163.com
 * @LastEditTime: 2024-07-18 23:38:55
 * @FilePath: \hz-official\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";

/* 路由 */
import router from "./router";
import store from './store'
import axios from 'axios'
import api from "./api/api";
import './assets/icons' // icon

/* swiper */
import "swiper/dist/css/swiper.min.css";
import Cookies from 'js-cookie'

import Element from 'element-ui'
import './assets/styles/element-variables.scss'
/* 重置样式 */
import "./assets/css/reset.min.css";
import "./assets/css/comm.css";

/* jquery */
import "jquery";

/* bootstarp */
import "./assets/css/bootstrap.min.css";
import "./assets/js/bootstrap.min";

/* animate.css */
import "animate.css";

import plugins from './plugins' // plugins
import { parseTime } from "@/utils/ruoyi";

/* 头部组件 */
import Header from "./components/Header";
Vue.component(Header.name, Header);

/* nav 组件 */
import Nav from "./components/Nav";
Vue.component(Nav.name, Nav);

/* 尾部组件 */
import Footer from "./components/Footer";
Vue.component(Footer.name, Footer);

/* 回到顶部 */
import GoTop from "./components/GoTop";
Vue.component(GoTop.name, GoTop);

/* 富文本 */
import Editor from "./components/Editor/index";
Vue.component('Editor', Editor)
// 分页组件
import Pagination from "@/components/Pagination";
Vue.component('Pagination', Pagination)
Vue.prototype.parseTime = parseTime


Vue.config.productionTip = false;

Vue.use(plugins)
Vue.use(Element, {
  size: Cookies.get('size') || 'medium' // set element-ui default size
})

// 换网页标签
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});

let configPath = `./static/config.json?t=` + new Date().getTime();
if (process.env.NODE_ENV === "development") {
  configPath = `./static/config.json?t=` + new Date().getTime();
}
axios.get(configPath).then((response) => {
  Vue.prototype.myUrl =
    process.env.NODE_ENV === "development"
      ? response.data.host.devHost
      : response.data.host.prodHost;
  // Vue.prototype.http = axios;
  Vue.prototype.api = api;

  new Vue({
    el: "#app",
    router,
    store,
    components: { App },
    template: "<App/>",
  });
});



// WEBPACK FOOTER //
// ./src/main.js